import React from 'react';

import { useRedeemDetailsContext } from '../../contexts/redeem-details';

import { ReviewTable } from './components/ReviewTable';
import { SentTable } from './components/SentTable';

interface RedeemDetailsTableProps {}

export const RedeemDetailsTable: React.FC<RedeemDetailsTableProps> = () => {
  const { redeemOffersStatus } = useRedeemDetailsContext();

  if (redeemOffersStatus === 'sent') {
    return <SentTable />;
  }

  return <ReviewTable />;
};
